module.exports = __webpack_public_path__ + "img/Trunked.66701173.png";